// extracted by mini-css-extract-plugin
export default {"checkboxIcon":"Checkbox__checkboxIcon___mNtt7"};